import enUS from '@i18n/cartUi/en-US.json'
import zhHK from '@i18n/cartUi/zh-HK.json'
import zhTW from '@i18n/cartUi/zh-TW.json'

import { getWordPressLocale } from '@utils/getWordPressLocale'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const resources = {
  zh_TW: {
    cartUi: zhTW,
  },
  en_US: {
    cartUi: enUS,
  },
  zh_HK: {
    cartUi: zhHK,
  },
}

const language = getWordPressLocale()
const cartUiI18nInstance = i18n.createInstance()

cartUiI18nInstance
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    interpolation: {
      escapeValue: false,
    },
    saveMissing: true,
    ns: ['cartUi'],
    defaultNS: 'cartUi',
  })

export default cartUiI18nInstance
